module.exports = __webpack_public_path__ + "img/3.e1af9e78.png";